import type { CityConfig } from "../city-template/types";

export const rawlinsConfig: CityConfig = {
  city: "Rawlins",
  state: "Wyoming",
  stateAbbr: "WY",
  slug: "rawlins",
  route: "/rawlins",
  title: "Emergency Passport Rawlins, WY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Rawlins, WY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Rawlins, Carbon County, Sinclair, and I-80 corridor travelers. Denver 290 miles — we bring the agency to you.",
  h1: "Emergency & Expedited Passport Services in Rawlins, WY",
  heroSubtitle: "Carbon County energy worker with an overseas rotation? I-80 corridor traveler with a last-minute international trip? Wyoming State Penitentiary employee planning family travel abroad? We help Rawlins residents — from Sinclair refinery workers to Carbon County ranchers to I-80 travelers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Expansive%20Wyoming%20high%20desert%20landscape%20with%20Rawlins%20nestled%20in%20the%20valley%20below%2C%20the%20historic%20Wyoming%20State%20Penitentiary%20frontier%20prison%20buildings%20with%20their%20distinctive%20stone%20architecture%2C%20the%20wide-open%20sagebrush%20plains%20stretching%20to%20distant%20mountains%20under%20a%20dramatic%20sky%20at%20sunrise%2C%20I-80%20corridor%20cutting%20through%20the%20high%20plains%20with%20the%20Sinclair%20refinery%20visible%20in%20the%20distance%2C%20editorial%20Western%20photography%20with%20rich%20golden%20tones%20and%20frontier%20atmosphere&width=1800&height=700&seq=rawlins-hero-2026&orientation=landscape",
  heroImageAlt: "Rawlins Wyoming high desert landscape with historic Frontier Prison and I-80 corridor",
  geoPosition: "41.7911;-107.2386",
  geoPlacename: "Rawlins, Wyoming",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 290 miles from Rawlins via I-80 and I-25; a 4.5+ hour drive one way",
  },
  nearbyCitiesZips: [
    { name: "Rawlins", zips: "82301" },
    { name: "Sinclair", zips: "82334" },
    { name: "Saratoga", zips: "82331" },
    { name: "Hanna", zips: "82327" },
    { name: "Elk Mountain", zips: "82324" },
    { name: "Medicine Bow", zips: "82329" },
    { name: "Encampment", zips: "82325" },
    { name: "Baggs", zips: "82321" },
  ],
  benefits: [
    { icon: "ri-road-map-line", title: "I-80 Corridor & Continental Divide Gateway", desc: "Rawlins sits astride I-80 at an elevation of 6,800 feet, straddling the Continental Divide. It's one of the most important highway stops between Cheyenne and Salt Lake City, with a constant flow of cross-country travelers who need passport services." },
    { icon: "ri-oil-line", title: "Sinclair Refinery & Energy Industry Hub", desc: "The Sinclair refinery in nearby Sinclair, WY, is a major employer and economic driver for Carbon County. Energy workers on international rotations, refinery professionals attending overseas conferences, and industry contractors need fast, reliable passport processing." },
    { icon: "ri-building-2-line", title: "Wyoming State Penitentiary & Government Employment", desc: "The Wyoming State Penitentiary in Rawlins is one of the area's largest employers. Corrections officers, administrative staff, and their families travel internationally — and need passport services that accommodate shift schedules." },
    { icon: "ri-flight-takeoff-line", title: "RWL — Rawlins Municipal Airport", desc: "RWL serves general aviation and charter flights. For commercial international connections, Rawlins travelers use Denver (290 miles) or Salt Lake City (280 miles) — both roughly equidistant. We coordinate passport timelines around these travel patterns." },
    { icon: "ri-landscape-line", title: "High Desert & Carbon County Ranching", desc: "Carbon County's high desert landscape — the Red Desert, the Snowy Range foothills, and the North Platte River Valley — is home to historic ranching operations with international agricultural connections." },
  ],
  internalLinks: [
    { name: "Expedited passport in Laramie, WY", route: "/laramie" },
    { name: "Fast passport in Rock Springs, WY", route: "/rock-springs" },
    { name: "Quick passport in Cheyenne, WY", route: "/cheyenne" },
    { name: "Urgent passport in Casper, WY", route: "/casper" },
    { name: "Wyoming passport services overview", route: "/states/wyoming" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Rawlins via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 4.5+ hours to Colorado. Rawlins residents can ship from any UPS Store, FedEx Office, or post office location across Carbon County.",
  fpcOfficeDistance: "Serving Rawlins, Sinclair, Saratoga, Hanna, Elk Mountain, Medicine Bow, Encampment, Baggs, and all Carbon County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rawlins and Carbon County. From downtown Rawlins to the Sinclair refinery community, from the North Platte River Valley ranchlands to the Red Desert — we serve all of south-central Wyoming. Our courier service eliminates the need to drive to Denver.",
  nearbyCitiesIntro: "We serve Rawlins and all Carbon County communities including Sinclair, Saratoga, and Hanna. We also serve I-80 travelers, energy industry professionals, and the historic ranching communities of south-central Wyoming.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Rawlins as simple as possible — with the reliability Carbon County energy workers, Wyoming State Penitentiary employees, and I-80 corridor travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee.",
  mistakesIntro: "Rawlins travelers encounter unique passport issues — from energy industry shift schedules to I-80 weather shipping delays to Carbon County rural address documentation. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "South-central Wyoming travelers — from Sinclair refinery professionals to Carbon County ranch families to I-80 corridor travelers — trust us when their international departure is days away and Denver is simply not an option.",
  faqIntro: "Have questions about expedited passports in Rawlins, WY? Here are the most common ones we hear from Carbon County travelers.",
  statePageRoute: "/states/wyoming",
  statePageName: "Wyoming",
  servicesIntro: "Whether you need a renewal before an energy industry overseas rotation, an emergency passport for a last-minute I-80 corridor departure, or a first-time passport for a Carbon County family vacation — Fast Passport Center handles it with reserved courier submission availability.",
  dmvWebsite: "https://www.dot.state.wy.us/driverservices",
  dmvLabel: "Wyoming Department of Transportation — Driver Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 290 miles from Rawlins", "4.5+ hour drive — impractical for Carbon County residents", "SLC agency also ~280 miles — also 4+ hours"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver or Salt Lake City trip needed", "Ideal for energy workers and Carbon County families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload shifts with government shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "No phone or email contact", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Sinclair refinery shift worker with an emergency international deployment? Family crisis abroad for a Carbon County resident? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Rawlins travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Rawlins residents renew fast — no agency visit required. Perfect for Carbon County energy workers and I-80 corridor frequent travelers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Carbon County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your trip stays on track.",
      bullets: ["DS-64 form guidance", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions for your Rawlins family trip abroad.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Sinclair refinery professionals and Carbon County energy workers with overseas rotations.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Rawlins travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Rawlins residents driving to Canada through Montana.",
      bullets: ["Wallet-size convenience", "Land and sea crossings", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rawlins WY", description: "Urgent passport processing for Rawlins Wyoming travelers." },
    { name: "Expedited Passport Renewal Rawlins WY", description: "Fast passport renewal for Rawlins residents." },
    { name: "First-Time Passport Rawlins WY", description: "New passport application services for Rawlins residents." },
    { name: "Child Passport Rawlins WY", description: "Minor passport services for Rawlins families." },
    { name: "Name Change Passport Rawlins WY", description: "Name correction for Rawlins residents." },
    { name: "Second Passport Rawlins WY", description: "Second passport services for Rawlins frequent travelers." },
  ],
  testimonials: [
    {
      name: "Mike D.",
      location: "Rawlins",
      rating: 5,
      text: "Sinclair refinery process engineer with a sudden trip to a conference in Abu Dhabi. Two weeks notice. Fast Passport Center expedited my renewal in 5 days. Driving to Denver — 290 miles — was out of the question with my shift schedule. Game changer for Carbon County energy professionals.",
      service: "Passport Renewal — Rush",
    },
    {
      name: "The Garcia Family",
      location: "Rawlins",
      rating: 5,
      text: "Wyoming State Penitentiary employee, wife, and two kids planning a family trip to the Dominican Republic. First passports for the kids. Fast Passport Center caught a birth certificate issue before it caused a rejection. All four passports arrived in 8 days. Incredibly smooth process.",
      service: "Family — New & Renewal Passports",
    },
    {
      name: "Janet R.",
      location: "Sinclair",
      rating: 5,
      text: "I-80 traveler passing through Rawlins on a cross-country trip when I realized my passport was expiring in 3 weeks and I had a Mexico trip booked. Fast Passport Center helped me from the road — I shipped documents from the Rawlins Post Office and had my new passport at my next destination in 6 days.",
      service: "Expedited Renewal — Traveler",
    },
    {
      name: "Bill C.",
      location: "Saratoga",
      rating: 5,
      text: "Carbon County rancher heading to an agricultural exchange in New Zealand. Three weeks to get a new passport. Fast Passport Center guided me through every step and I had my passport in 7 days. For south-central Wyoming residents, this is the only realistic fast option.",
      service: "New Passport — Rush",
    },
  ],
  facilities: [
    {
      id: "rawlins-1",
      name: "Rawlins Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "106 4th St",
      city: "Rawlins",
      state: "WY",
      zip: "82301",
      phone: "(307) 324-3521",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Downtown Rawlins",
      website: "https://tools.usps.com/find-location.htm?location=1378519",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Rawlins and Carbon County. Appointment availability limited — book well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "rawlins-2",
      name: "Carbon County Clerk of District Court",
      type: "County Clerk Passport Acceptance",
      address: "415 W Pine St, Suite 104",
      city: "Rawlins",
      state: "WY",
      zip: "82301",
      phone: "(307) 328-2655",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Rawlins — Carbon County Courthouse",
      website: "https://www.carbonwy.com/",
      websiteLabel: "Carbon County Website",
      notes: "Alternative to post office acceptance. Appointment recommended. Accessible for government employees at county offices.",
      icon: "ri-government-line",
    },
    {
      id: "rawlins-3",
      name: "Saratoga Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "109 W Main St",
      city: "Saratoga",
      state: "WY",
      zip: "82331",
      phone: "(307) 326-8311",
      hours: "Mon–Fri 8:00 AM – 12:00 PM, 1:00 PM – 4:00 PM (appointment required)",
      distance: "Saratoga — about 45 miles southeast of Rawlins via WY-130",
      website: "https://tools.usps.com/find-location.htm?location=1379652",
      websiteLabel: "USPS Location",
      notes: "Serves the North Platte River Valley and southern Carbon County. Limited morning-only hours.",
      icon: "ri-mail-line",
    },
    {
      id: "rawlins-4",
      name: "Laramie Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "152 N 5th St",
      city: "Laramie",
      state: "WY",
      zip: "82070",
      phone: "(307) 745-4801",
      hours: "Mon–Fri 8:30 AM – 4:30 PM (appointment required)",
      distance: "Laramie — about 100 miles east of Rawlins via I-80",
      website: "https://tools.usps.com/find-location.htm?location=1368492",
      websiteLabel: "USPS Location",
      notes: "Larger facility with more appointment availability than Rawlins. About 1.5 hours from Rawlins via I-80 — useful when Rawlins is booked.",
      icon: "ri-mail-line",
    },
    {
      id: "rawlins-5",
      name: "Rock Springs Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2829 Commercial Way",
      city: "Rock Springs",
      state: "WY",
      zip: "82901",
      phone: "(307) 362-6622",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Rock Springs — about 110 miles west of Rawlins via I-80",
      website: "https://tools.usps.com/find-location.htm?location=1378522",
      websiteLabel: "USPS Location",
      notes: "Alternative facility in southwestern Wyoming. About 2 hours from Rawlins via I-80. Useful for I-80 corridor travelers.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 290 miles and 4.5+ hour drive from Rawlins", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO; 9+ hour round trip from Rawlins", fpc: "Most Rawlins travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Practicality for Rawlins Residents", agency: "290 miles to Denver — impractical for Carbon County residents", fpc: "Entirely remote — ship from Rawlins, receive at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees — plus travel costs and time off work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Carbon County Context", agency: "No Rawlins-specific guidance — no I-80, energy industry, or high desert expertise", fpc: "Full Carbon County knowledge — Sinclair refinery, penitentiary employees, I-80 corridor" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Energy Industry Rotation Schedule Conflicts",
      description: "Sinclair refinery and energy workers on rotational schedules — 2 weeks on, 2 weeks off, or similar — have narrow windows for handling passport acceptance visits and document shipping. Plan your passport tasks for the first few days of your off-rotation to leave plenty of processing time before your next departure.",
    },
    {
      icon: "ri-error-warning-line",
      title: "I-80 Winter Weather and Overnight Shipping",
      description: "Rawlins sits at 6,800 feet on the Continental Divide. I-80 winter closures between Rawlins and Laramie or Rawlins and Rock Springs are common. Overnight document shipping can be delayed 1-2 days during major winter storms. Build extra buffer into winter passport timelines.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Carbon County Rural Address Documentation",
      description: "Ranch addresses and rural route numbers in Carbon County — especially around Hanna, Elk Mountain, and Medicine Bow — may differ from residential addresses on supporting documents. We review all documentation to catch mismatches before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Government Employee Documentation Requirements",
      description: "Wyoming State Penitentiary employees and other government workers may have specific identification and documentation considerations. Federal and state employee IDs are not accepted as primary identification for passport applications — a state driver's license or other approved ID is required.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Denver Is Close Enough for a Day Trip",
      description: "At 290 miles, Denver is the closest passport agency to Rawlins — but a 9+ hour round trip plus appointment time makes it a 12+ hour day. For shift workers at Sinclair or the penitentiary, this is impossible to schedule. Our courier service eliminates the need entirely.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether an energy industry rotation, Carbon County family trip, or I-80 corridor departure." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — energy worker, penitentiary employee, or Carbon County rancher." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Rawlins clients ship from the Rawlins Post Office on 4th Street." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Rawlins travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Rawlins or Carbon County address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Rawlins, Wyoming?", a: "We offer Rawlins-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest regional passport agency is in Denver (290 miles away) or Salt Lake City (~280 miles) — both are 4.5+ hour drives. Our remote courier service is the only practical fast option." },
    { q: "Do I need to visit a Rawlins office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Rawlins Post Office or Carbon County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Carbon County address." },
    { q: "Where can I get passport acceptance near Rawlins?", a: "Rawlins has acceptance facilities at the Main Post Office on 4th Street and the Carbon County Clerk at the courthouse on Pine Street. Nearby alternatives include USPS locations in Saratoga, Laramie, and Rock Springs along the I-80 corridor." },
    { q: "I work at the Sinclair refinery — can you accommodate my shift schedule?", a: "Yes. We understand that energy industry shift workers have limited windows for handling paperwork. You can start your online order anytime. The acceptance facility visit needs to happen during post office or county clerk business hours — we recommend scheduling for your first day off-rotation." },
    { q: "What documents do Rawlins applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent. We provide a Carbon County-specific checklist." },
    { q: "How does I-80 winter weather affect my passport timeline?", a: "Rawlins sits at 6,800 feet on the Continental Divide, and I-80 closures between Rawlins and both Laramie and Rock Springs are common in winter. We recommend building in 1-2 extra buffer days during winter months (November through March) when timing your overnight document shipping." },
    { q: "Can I get a passport photo in Rawlins?", a: "Yes. The Rawlins Post Office offers limited on-site passport photos. Walmart Supercenter and local pharmacies also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What is the best price for expedited passport service in Rawlins?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "Is Denver or Salt Lake City better for a passport agency appointment?", a: "Denver is about 290 miles (4.5 hours) via I-80/I-25, and Salt Lake City is about 280 miles (4 hours) via I-80. Both are roughly equidistant from Rawlins. Neither is practical for a day trip when factoring in appointment times and travel. Our courier service makes both cities irrelevant." },
    { q: "Can you help with passports for Wyoming State Penitentiary employees?", a: "Yes. We regularly serve government employees in Rawlins, including those at the Wyoming State Penitentiary. We understand the shift schedule constraints and documentation requirements unique to federal and state employees. Start online anytime — we work around your availability." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Rawlins Residents",
    intro: "Rawlins' position on I-80 at the Continental Divide, combined with its role as Carbon County's seat and an energy industry hub, creates unique passport timing considerations. Here's what south-central Wyoming travelers need to know.",
    cards: [
      {
        icon: "ri-road-map-line",
        title: "I-80 Corridor — The Rawlins Advantage",
        subtitle: "Straddling the main east-west artery of southern Wyoming",
        description: "Rawlins is one of the most important stops on I-80 between Cheyenne and Salt Lake City, roughly equidistant between Denver (290 miles) and SLC (280 miles). This position means Rawlins travelers have two major international airport options, both a 4-5 hour drive. For domestic connections, Laramie's airport is 100 miles east, and Denver International is the primary international gateway.",
        tip: "For international flights, compare both Denver (DIA) and Salt Lake City (SLC) options. DIA is slightly more accessible via I-80/I-25 and typically has more flight options. For domestic connections to international gateways, Laramie Regional Airport offers Denver connections that can save the drive.",
      },
      {
        icon: "ri-oil-line",
        title: "Energy Industry Travel Patterns",
        subtitle: "Refinery rotations and international energy conferences",
        description: "The Sinclair refinery and Carbon County's broader energy sector create regular international travel needs — from overseas rotations for specialized engineers to international energy conferences and training programs. Energy workers on rotational schedules face unique passport challenges because their town days are limited and their international departure dates are often fixed by project timelines.",
        tip: "Energy workers should maintain passport validity year-round. International rotation opportunities often arise with 2-4 weeks notice. Having an expired passport when a rotation is offered means either missing the opportunity or relying on emergency processing — which adds stress and cost.",
      },
      {
        icon: "ri-landscape-line",
        title: "High Desert & Winter Travel Challenges",
        subtitle: "Navigating the Continental Divide at 6,800 feet",
        description: "Rawlins is one of the highest-elevation cities on I-80, sitting at 6,800 feet on the Continental Divide. The stretch of I-80 between Rawlins and Laramie — known as the Summit — is notorious for winter closures due to wind, snow, and whiteout conditions. This can affect both document shipping and travel to airports.",
        tip: "During winter (November–March), build extra buffer days into your passport timeline. Monitor WYDOT road conditions for I-80 before shipping documents or driving to Denver or SLC airports. The Rawlins-to-Laramie I-80 segment is frequently the first to close during winter storms.",
      },
      {
        icon: "ri-building-2-line",
        title: "Carbon County Government & Institutional Travel",
        subtitle: "Penitentiary employees and county government professionals",
        description: "As the Carbon County seat and home to the Wyoming State Penitentiary, Rawlins has a significant government workforce. Corrections professionals, county administrators, and law enforcement personnel travel internationally for conferences, training exchanges, and family vacations. These travelers need passport services that accommodate government work schedules.",
        tip: "Government employees should check whether their agency offers any passport assistance or accelerated processing programs. Some federal agencies have internal passport offices, but most state and county employees use standard passport channels. Start early — government travel approvals often require passport information months before the actual trip.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Rawlins & the High Desert Frontier",
      description: "Rawlins is Wyoming at its most authentic — a high desert railroad town turned I-80 crossroads, surrounded by some of the most dramatic sagebrush country in the American West. The historic Wyoming Frontier Prison, with its distinctive stone facade and museum exhibits, tells the story of Wyoming's territorial past. The Sinclair refinery — with its iconic green dinosaur logo visible for miles — powers the local economy. And the Red Desert to the south, one of the last intact high-desert ecosystems in North America, stretches toward the horizon with a stark beauty that defines this corner of the Equality State.",
    },
  },
  destinations: {
    title: "Where Rawlins Travelers Go — And Why Passports Get Urgent",
    intro: "Rawlins' identity as an I-80 crossroads, energy industry hub, and high desert Carbon County seat shapes its international travel patterns.",
    stats: [
      { stat: "35%", label: "of Rawlins expedited requests involve energy industry travel or rotations" },
      { stat: "2–4 Weeks", label: "average lead time from trip booking to departure" },
      { stat: "Jun–Sep", label: "peak season for Carbon County family travel and energy conferences" },
      { stat: "290 Miles", label: "to Denver passport agency — SLC is 280 miles — neither practical" },
    ],
    destinations: [
      { name: "Middle East", context: "Energy industry conferences in Abu Dhabi, Dubai, and Doha, refinery technology exchanges, specialized engineering training programs", urgency: "Fixed-date conferences and rotation start dates", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Energy industry partnerships in Alberta, Calgary conferences, cross-border hunting and fishing trips, Carbon County ranch exchanges", urgency: "Seasonal outdoor recreation and industry conference schedules", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter resort vacations for energy workers and families, cruise departures connecting through Denver or SLC, all-inclusive getaways", urgency: "Winter vacation planning and off-rotation travel windows", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Energy technology expos in Germany and the Netherlands, Carbon County family heritage travel, refinery equipment training in Italy", urgency: "Fixed-date trade shows and training program start dates", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Energy sector partnerships in Brazil and Venezuela, agricultural exchanges, adventure tourism", urgency: "Project deployment and agricultural calendar timelines", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Energy equipment manufacturing partnerships in China and South Korea, refining technology conferences, international training programs", urgency: "Fixed-date conferences and project timelines", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Wyoming Service Areas",
    crossLinksDesc: "We serve travelers across the Equality State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Laramie", route: "/laramie" },
      { name: "Rock Springs", route: "/rock-springs" },
      { name: "Cheyenne", route: "/cheyenne" },
    ],
  },
  photoLocations: [
    { name: "Rawlins Main Post Office", address: "106 4th St, Rawlins, WY 82301", hours: "Mon–Fri 9 AM – 3:30 PM (limited photo service)" },
    { name: "Walmart Supercenter — Rawlins", address: "2390 E Cedar St, Rawlins, WY 82301", hours: "Daily 6 AM – 11 PM" },
    { name: "Smith's Food & Drug — Rawlins", address: "2103 E Cedar St, Rawlins, WY 82301", hours: "Daily 6 AM – 11 PM" },
  ],
  dmvLocations: [
    {
      name: "Carbon County Treasurer — Motor Vehicle Division",
      address: "415 W Pine St, Suite 109, Rawlins, WY 82301",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Wyoming DOT Driver Services — Rawlins",
      address: "1400 E Cedar St, Rawlins, WY 82301",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver license examinations, REAL ID, and driving records.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RWL",
      name: "Rawlins Municipal Airport (Harvey Field)",
      distance: "About 2 miles northeast of downtown Rawlins (5 minutes via US-287)",
      address: "1400 Airport Rd, Rawlins, WY 82301",
      note: "General aviation airport with limited commercial service. Primarily serves private and charter flights. Most travelers use Denver or SLC for commercial connections.",
      flightUrl: "https://www.rawlinswy.gov/airport",
      flightLabel: "RWL Airport",
      featured: true,
    },
    {
      code: "LAR",
      name: "Laramie Regional Airport",
      distance: "About 100 miles east of Rawlins (1 hour 40 minutes via I-80)",
      address: "555 N General Brees Rd, Laramie, WY 82070",
      note: "Regional airport with connections to Denver International Airport via United Express. The closest commercial airport to Rawlins.",
      flightUrl: "https://www.laramieairport.com/",
      flightLabel: "Laramie Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Wyoming birth certificates from the Wyoming Department of Health Vital Statistics Services.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Wyoming Vital Statistics Services.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Carbon County Clerk. Certified copies for name changes and passport applications.",
      url: "https://www.carbonwy.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Carbon County District Court.",
      url: "https://www.carbonwy.com/",
    },
  ],
};